'use es6';

import * as ProductLines from 'self-service-api/constants/ProductLines';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
export const CrmSuiteCards = [ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE];
export default {
  [ProductLines.MARKETING]: [ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE],
  [ProductLines.SALES]: [ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE],
  [ProductLines.SERVICE]: [ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE],
  [ProductLines.CMS]: [ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE],
  [ProductLines.OPERATIONS]: [ProductLevels.STARTER, ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE]
};